import { WineCondition, WinePurchaseCondition } from './constants';

const attributes = {
  wine_blend: {
    friendly: 'Grape/Blend',
    validations: {
      maxLength: 150,
    },
  },
  wine_producer: {
    friendly: 'Producer',
    validations: {
      maxLength: 150,
    },
  },
  wine_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  wine_region: {
    friendly: 'Region',
    validations: {
      maxLength: 150,
    },
  },
  wine_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },
  wine_alc: {
    friendly: 'Alcohol Content',
    validations: {
      maxLength: 150,
    },
  },
  wine_size: {
    friendly: 'Size',
    validations: {
      maxLength: 150,
    },
  },
  wine_rating: {
    friendly: 'Rating',
    validations: {
      maxLength: 150,
    },
  },
  wine_production: {
    friendly: 'Production',
    validations: {
      maxLength: 150,
    },
  },
  wine_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: WineCondition,
    },
  },

  wine_purchase_conditon: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: WinePurchaseCondition,
    },
  },

};

export default attributes;

export const WineDefaultSplitAttribute = 'wine_blend';

export const WineItemSearchAttributes = [];

export const WineOverviewAttributes = ['title', 'wine_blend', 'wine_year', 'wine_country', 'wine_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const WineSpecificationAttributes = ['wine_producer', 'wine_region', 'wine_alc', 'wine_size', 'wine_rating', 'wine_production'];

export const WinePurchaseAttributes = ['purchase_date', 'purchase_price', 'wine_purchase_conditon', 'purchase_contact', 'purchase_notes'];

export const WineDetailAttributes = [];

export const WineRequiredAttributes = [];

export const WineDisplayAttributes = ['wine_blend', 'wine_producer', 'wine_year', 'wine_region', 'wine_country', 'tags'];

export const WineSliderGalleryAttributes = {
  titleKey: 'wine_country',
  subtitleKey: 'wine_blend',
};



// WEBPACK FOOTER //
// ./src/config/wineDataAttributes.js